module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/social/dribbble-7dbe5a10c000b4bd941b2eae927cab44.svg";